export interface ICharityNameForGame {
  Id: string;
  Name: string;
  // Deactivated charities are in the list on purpose — one can still be owed money — so the pickers say so
  // rather than offering a dead charity that looks like any other (#1505).
  Active: boolean;
}

/**
 * A charity as a picker option. Deactivated charities stay in the list — one can still be owed money and
 * that payout has to remain recordable — so the name says so, the same way the payee assignment tables do,
 * rather than offering a dead charity that reads like any other (#1505).
 */
export function charityOption(charityP: ICharityNameForGame): { id: string; name: string } {
  return {
    id: charityP.Id,
    name: charityP.Active ? charityP.Name : `${charityP.Name} (inactive)`
  };
}
